import React from 'react'
import styled from 'styled-components'
import useSeti from '@/hooks/useSeti'
import { themeGet } from '@styled-system/theme-get'
import useBootstrapData from '@/hooks/useBootstrapData'
import createMarkup from '@/shared-utils/create-markup'

const StyledFooter = styled('div')`
  display: none;

  ${themeGet('mediaQueries.md')} {
    display: block;
  }
`

function Footer({ footerHTML }: { footerHTML: string }) {
  const { isMobile } = useBootstrapData()
  const showFooterWithAccordion = useSeti('GLOBAL_RESPONSIVE_FOOTER', isMobile)

  const footerContent = showFooterWithAccordion ? (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={createMarkup(footerHTML)}
      id="pcln-global-footer"
    />
  ) : (
    <StyledFooter id="expr-ftr" className="experimental-footer">
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={createMarkup(footerHTML)}
        id="pcln-global-footer"
        style={{ visibility: 'hidden' }}
      />
    </StyledFooter>
  )

  return footerHTML.length > 0 ? footerContent : null
}

export default Footer
